define([
    'underscore',
    'text!./templates/basler-list-item-selector.html',
], (_, templateStr) => {

    const directive = function () {
        return {
            restrict: 'AE',
            template: templateStr,
            scope: {
                model: '=',
                options: '=',
                trackBy: '&',
                nameFn: '&?optionName',
                valueFn: '&?optionValue',
                disabled: '=?',
            },
            link: linkFunction,
        };

        function linkFunction($scope, element, attr) {
            bindFunctions();

            $scope.collapsed = Boolean($scope.model);

            $scope.onClick = function (item) {
                if ($scope.disabled) {
                    return;
                }
                $scope.collapsed = !$scope.collapsed;
                $scope.model = $scope.optionValue(item); //DO NOT REMOVE, it won't select element and will repaint nothing
            };

            $scope.showItem = function (item) {
                return (!$scope.collapsed || $scope.optionValue(item) === $scope.model);
            };

            /**
             * This will check whether option-name and option-value are given by directive caller.
             * If not, name and value will be the options itself, otherwise the callbacks are used.
             */
            function bindFunctions() {
                if (attr.optionName) {
                    $scope.optionName = function (option) {
                        return $scope.nameFn({option: option});
                    };
                } else {
                    $scope.optionName = _.identity;
                }

                if (attr.optionValue) {
                    $scope.optionValue = function (option) {
                        return $scope.valueFn({option: option});
                    };
                } else {
                    $scope.optionValue = _.identity;
                }
            }
        }

    };
    directive.$inject = [];

    return directive;
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/basler/BaslerListItemSelector.js